import { z } from 'zod';

import { ClientSchema } from '@t/api';

export const addUserSchema = z.object({
  address: z.string(),
  cellPhone: z.number().optional(),
  city: z.string(),
  clientGroup: z.string(ClientSchema),
  confirmPassword: z.string(),
  department: z.string(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  middleName: z.string().optional(),
  password: z.string(),
  role: z.string(),
  state: z.string(),
  title: z.string().optional(),
  zipCode: z.number(),
});

export type AddUserForm = z.infer<typeof addUserSchema>;
